import { CasStackRow } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import CasIconButton from 'src/compass/shared/components/CasButton/CasIconButton';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { useTouchpointCache } from './RenderTouchpointFrequency';

interface IProps {
  id: number;
  handoffRequested: boolean;
  handoffRequestedByName?: string | null;
  handoffRequestedByCurrentUser: boolean;
}

export default function RenderHandoff({
  id,
  handoffRequested,
  handoffRequestedByName,
  handoffRequestedByCurrentUser,
}: IProps) {
  const { updateHandoffRequested } = useTouchpointCache();

  const { mutate: requestHandoff } = useUpdateMutation({
    url: 'Utilities/EntityTouchpoint/RequestHandoff',
    showLoader: false,
    onSuccess: onSuccessEnqueueSnackbar,
  });

  const { mutate: clearHandoff } = useUpdateMutation({
    url: 'Utilities/EntityTouchpoint/ClearHandoff',
    showLoader: false,
    onSuccess: onSuccessEnqueueSnackbar,
  });

  const onRequest = () => {
    // optimistic - the current user is the requester
    updateHandoffRequested({ id, handoffRequested: true, handoffRequestedByCurrentUser: true });
    requestHandoff(
      { entityId: id },
      {
        onError: () =>
          updateHandoffRequested({
            id,
            handoffRequested: false,
            handoffRequestedByCurrentUser: false,
          }),
      }
    );
  };

  const onClear = () => {
    updateHandoffRequested({ id, handoffRequested: false, handoffRequestedByCurrentUser: false }); // optimistic
    clearHandoff(
      { entityId: id },
      {
        onError: () =>
          updateHandoffRequested({
            id,
            handoffRequested: true,
            handoffRequestedByCurrentUser: true,
          }),
      }
    );
  };

  if (handoffRequested) {
    return (
      <CasStackRow alignItems="center" backgroundColor="#a9ffa9">
        {handoffRequestedByCurrentUser
          ? 'Requested'
          : `Requested by ${handoffRequestedByName}`}
        {/* Only the employee who made the request can clear it. */}
        {handoffRequestedByCurrentUser && (
          <CasIconButton
            icon="mingcute:close-line"
            width={16}
            height={16}
            tooltip="Clear handoff request"
            onClick={onClear}
          />
        )}
      </CasStackRow>
    );
  }

  return <CasLink onClick={onRequest}>Submit request</CasLink>;
}
